module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am316-749bedfb9fa18a9e9efc39f16993d896.jpg";